class CartRelatedProducts extends HTMLElement {
  constructor() {
    super();

    this.cacheKey = "ll-cache-add-product";
    this.prevProductId = "";
    this.sectionId = "cart-related-products";
    this.limit = this.dataset.size;
    this.intent = "related";
    this.cacheDom = new Map();

    this.listenEvent();
  }

  connectedCallback() {
    this.renderRecommendations();
  }

  get productId() {
    return localStorage.getItem(this.cacheKey);
  }

  listenEvent() {
    document.addEventListener("variant:add", (event) => {
      const productId = event.detail.items?.[0]?.product_id;
      if (!productId) {
        return;
      }

      localStorage.setItem(this.cacheKey, productId);
    });
  }

  async renderRecommendations() {
    const productId = this.productId;
    const sectionId = this.sectionId;

    const isPrev = productId === this.prevProductId;

    if (!productId || isPrev) {
      return;
    }

    this.prevProductId = productId;

    let text = this.cacheDom.get(productId);
    if (!text) {
      const response = await fetch(
        `${Shopify.routes.root}recommendations/products?product_id=${productId}&section_id=${sectionId}&limit=${this.limit}&intent=${this.intent}`
      );
      text = (await response.text()).replace(/<(\w+)([^>]*)>/, "<div>");
      this.cacheDom.set(productId, text);
    }

    this.innerHTML = text;
  }
}

if (!window.customElements.get("cart-related-products")) {
  window.customElements.define("cart-related-products", CartRelatedProducts);
  window.cartRelatedProducts = document.querySelector("cart-related-products");
}
